var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.948,
    height: 23.787,
    viewBox: "0 0 29.948 23.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#011d29;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.955 -5.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.786,6H28.073a2.794,2.794,0,0,1,2.786,2.786V25.5a2.794,2.794,0,0,1-2.786,2.786H5.786A2.794,2.794,0,0,1,3,25.5V8.786A2.794,2.794,0,0,1,5.786,6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.859,9,16.93,18.751,3,9",
    transform: "translate(0 -0.214)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f6ab210ec6cdc676d44d54b645baf20d.svg";
export { ForwardRef as ReactComponent };